

// @ts-nocheck

import Vue from "vue";
import FBLShared from 'fblshared';
import { RatingScaleValues } from "../../../../../../../Overarching Resources/TS/Survey/types";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import InlineTooltipQuestion from './InlineTooltipQuestion.vue'

export default Vue.extend({
  data() {
    return {
      shareRatingLocal: [7, 10],
      minimum: 0,
      maximum: 10
    };
  },
  components: {
      VueSlider,
      InlineTooltipQuestion
  },
  created(): void {          
      //get the current value, initiate the local variable
        this.computeMinMax(this.ratingType)
        if (this.field === 'all') {
            //set the local var according to rating
            switch (this.ratingType) {
                case "csat":
                    this.shareRatingLocal = [1, 5]
                break
            case "nps":
                    this.shareRatingLocal = [0, 10]
                break
            case "star":
                    this.shareRatingLocal = [1, 5]
                break
        }
        } else {
            this.shareRatingLocal = [this.field.low, this.field.high]
        }
  },
  methods: {
    computeMinMax(rT): void {
      switch (rT) {
        case "csat":
          this.minimum = 1
          this.maximum = 5
          break
        case "nps":
          this.minimum = 0
          this.maximum = 10
          break
        case "star":
          this.minimum = 1
          this.maximum = 5
        break
        }
    },
    getSliderColor(): string {

      if (this.$store.state.dash.brandHex) return this.$store.state.dash.brandHex
      return '#A705D5'

      /*
        let lowerThreshold = 5
        let upperThreshold = 6

        if (this.ratingType !== 'nps') {
            lowerThreshold = 2
            upperThreshold =3
        }

      return minRating <= lowerThreshold ? "#EA5455" : minRating <= upperThreshold ? "#FF9F43" : "#28C76F";*/
    }
  },
  props: {
    fieldAddress: Array,
    readOnly: {
      type: Boolean,
      default: false
    },
    label: String,
    tip: {
      default: false,
      type: [String, Boolean]
    }
  },
  watch: {
      shareRatingLocal(v): void {
          //update the field

          if (v[0] === this.minimum && v[1] === this.maximum) {
              this.field = 'all'
          } else {
              this.field = {
                  low: v[0],
                  high: v[1]
              }
          }          
      },
      ratingType: {
        handler(newV,oldV): void {
      //if the rating type changes, calculate the new local scale        
        switch (oldV) {
          case "nps":
            if (newV !== 'nps') {
              //noconsoleconsole.log('changing from nps to:' + [new FBLShared.NPSRating(this.shareRatingLocal[0]).inFive,new FBLShared.NPSRating(this.shareRatingLocal[1]).inFive] )
              //this is producing a lifecycle/timing error with vue slider, because value doesn't work with min max:
              this.shareRatingLocal = [new FBLShared.NPSRating(this.shareRatingLocal[0]).inFive,new FBLShared.NPSRating(this.shareRatingLocal[1]).inFive]
              this.computeMinMax(newV)
            }
          break          
          default:
            if (newV === 'nps') {
              //noconsoleconsole.log('changing from five to:' + [new FBLShared.FiveRating(this.shareRatingLocal[0]).inNPS,new FBLShared.FiveRating(this.shareRatingLocal[1]).inNPS] )
              
              //this is producing a lifecycle/timing error with vue slider, because value doesn't work with min max:              
              this.shareRatingLocal = [new FBLShared.FiveRating(this.shareRatingLocal[0]).inNPS,new FBLShared.FiveRating(this.shareRatingLocal[1]).inNPS]
              this.computeMinMax(newV)

              setTimeout(() => {
                //noconsoleconsole.log(this)
              }, 1)

            }    
          break
      }
        },
        immediate: true
      }
  },
  computed: { 
    readOnlyDotStyles(): any {
      
      if (this.readOnly) {
        if (this.shareRatingLocal[0] === this.shareRatingLocal[1]) {
          return {
            cursor: 'default',
            backgroundColor: this.getSliderColor(this.shareRatingLocal[0]),
            width: '30px',
            borderRadius: '4px',
            height: '6px',
            marginTop: '4px',
            marginLeft: this.shareRatingLocal[0] === this.maximum ? '-15px': '0'
          }
        } else {
          return {
            display: 'none',
          }
        }        
      } else {
        return {}
      }
          
    },  
    ratingType(): string | false {
      return this.$store.state.survey.surveySetup.ratingType
    },   
    field: {
      get: function (): RatingScaleValues {        
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: RatingScaleValues): void {
        this.$store.commit("survey/CHANGE_FIELD", {
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
    getRatingString(): string {
      if (this.shareRatingLocal[0] === this.minimum && this.shareRatingLocal[1] === this.maximum) return 'all'
      return String(this.shareRatingLocal[0] === this.shareRatingLocal[1] ? this.shareRatingLocal[0] : this.shareRatingLocal[0] + " to " + this.shareRatingLocal[1])
    }
  },
});
